// Whether an order's refunds are paid through its channel's API, rather
// than by hand in the channel's own seller UI. The BE decides per order
// (refunds_via_channel): since 2026-10-31 a BargainFox order with its
// channel reference is refunded by "Issue Refund" through BargainFox.
// Every other order — other channels, and BargainFox replacement, exchange
// and manual orders — keeps the manual-refund notice and the "Refund
// issued" button. An order shape without the field counts as manual.
export const refundsViaChannel = (order: { refunds_via_channel?: boolean } | null | undefined): boolean =>
    order?.refunds_via_channel === true;
